'use strict';

const SELECTOR = 'js-site-footer';

export function init() {
    const element = document.querySelector('.' + SELECTOR),
    page = document.querySelector('html');

    if (element === null) {
        return false;
    }

    function footerHeight() {
        page.style.setProperty('--footer-height', `${element.offsetHeight}px`);
    }

    footerHeight(), window.addEventListener('resize', function() {
        footerHeight();
    }, 100);


}